<template>
    <div style="margin-top:-2.3%" class="px-2 border-top pt-2">
        <SlaSettingUI type="helpdesk" alias="Helpdesk" :catList="catList" :catValue="catValue" @onSubmit="onSubmit" :catTimesAmount="catTimesAmount"/>
    </div>

</template>

<script>
import SlaSettingUI from "../slaSetting.vue"
import { BRow, BCol } from "bootstrap-vue";
import { generateCatInit, catNameHolder } from "../../util"
import CatService from "@/services/setting/cat";

export default {
    props: {
        isTriggerFetch:{
            type:Boolean,
            default:false
        }
    },
    components: { BRow, BCol, SlaSettingUI },
    
    data() {
        return {
            mode:"create",
            catIdHolder:{},
            catList: [],
            catValue: {
                "CAT1": null,
                "CAT2": null,
                "CAT3": null,
                "CAT4": null,
                "CAT5": null
            },
            catTimesAmount:{
                CAT1:0,
                CAT2:0,
                CAT3:0,
                CAT4:0,
                CAT5:0
            }
        }
    },
    computed: {
        paramSubCompanyId() {
            return this.$route.query.scid
        },
    },
    watch: {
        isTriggerFetch: {
            immediate: true,
            handler(val) {
                const catSettingValue = this.$store.getters["sla/getCatSettingSelected"]
                this.onSubmit(catSettingValue)  
            }
        }
    },
    created() {
        this.catList = generateCatInit("helpdesk", this.paramSubCompanyId);
        this.onFetchCat()
    },
    methods: {
        async onFetchCat(){
            const result = await CatService.GetCatByType(this.paramSubCompanyId, "helpdesk")
            console.log("result", result)
            if(result.status == "success" && result?.data?.items?.length > 0){
                const cats = result.data?.items
                
                let catsHolder = {}
                for (let i = 0; i < cats.length; i++) {
                    const cat = cats[i];
                    catsHolder[cat.catCode] = cat.fixTime
                    this.catIdHolder[cat.catCode] = cat.id
                }

                this.mode = "edit"
                this.catValue = {...this.catValue, ...catsHolder}                
            }

            if(result.data?.catTimesAmount){
                this.catTimesAmount = result.data?.catTimesAmount
            }
        },
        async onSubmit(data) {
            const brandId = this.paramSubCompanyId
            let output = []
            
            for (let i = 0; i < this.catList.length; i++) {
                const cat = this.catList[i];
                const catValue = data[cat.catCode]
                let catData = {
                    type: "helpdesk",
                    brandId: brandId,
                    catCode: cat.catCode,
                    catName: catNameHolder(cat.catCode),
                    responseTime: "",
                    fixTime: catValue ? parseFloat(catValue) : "",
                    responseTimeOutZone: "",
                    fixTimeWithCentralOutZone: "",
                    fixTimeNoCentralOutZone: "",
                    isCentralZone: false
                }

                if(this.mode == "edit"){
                    catData.id = this.catIdHolder[cat.catCode]
                }
                output.push(catData)
                
            }


            if(output.length ==0){
                return
            }

            if(this.mode == "create"){
                await CatService.InsertCat(output)
                alert("บันทึกสําเร็จ")
            }else{
                await CatService.UpdateCat(output)
                alert("บันทึกสําเร็จ")
            }
            
            await this.onFetchCat()
            console.log("saved", data)
            console.log("output", output)
        }
    }
}
</script>